/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import DownIcon from 'mdi-react/ChevronDownIcon';
import TopbarNavLink from '../../../../admin/Layout/topbar_with_navigation/tobar_nav/TopbarNavLink';
import { getContentApprovalsFilter } from '../../../../../shared/helpers/Filter';
import AccessComponent from '../../../../../shared/components/auth/AccessComponent';

const TopbarNav = ({
  creatorsLink,
  prospectsLink,
  contentApprovalsFilters,
  priceApprovalLink,
}) => {
  const startDate = moment().startOf('month').toISOString();
  const endDate = moment().endOf('day').toISOString();
  // 
  const session = useSelector(state => state.session);
  const isOwner = session?.role === 'owner';

  return (
    <nav className="topbar__nav topbar__nav__brand">
      <Link className="topbar__nav-link" to="/">Overview</Link>
      {/* <Link className="topbar__nav-link" to="/">Home</Link> */}
      <Link className="topbar__nav-link" to={creatorsLink}>Creators</Link>
      {session.advertiser?.enablePriceApprovalsOnBrandPortal && (
        <Link className="topbar__nav-link" to={priceApprovalLink}>Price Approval</Link>
      )}
      <Link className="topbar__nav-link" to={prospectsLink}>Prospects</Link>
      {session.advertiser?.displayBrandConfirmedDeals && isOwner && (
        <UncontrolledDropdown className="topbar__nav-dropdown">
          <DropdownToggle className="topbar__nav-dropdown-toggle">
            Confirmed Deals <DownIcon />
          </DropdownToggle>
          <DropdownMenu className="topbar__nav-dropdown-menu dropdown__menu">
            <DropdownItem>
              <TopbarNavLink title="Pipeline" route="/deals-pipeline" />
            </DropdownItem>
            <DropdownItem>
              <TopbarNavLink title="Published" route="/deals-published" />
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      )}
      <UncontrolledDropdown className="topbar__nav-dropdown">
        <DropdownToggle className="topbar__nav-dropdown-toggle">
          Content <DownIcon />
        </DropdownToggle>
        <DropdownMenu className="topbar__nav-dropdown-menu dropdown__menu">
          <DropdownItem>
            <TopbarNavLink title="Published" route="/content" />
          </DropdownItem>
          <DropdownItem>
            <TopbarNavLink
              title="Approvals"
              route={`/content-approvals?${getContentApprovalsFilter(session.role === 'auditor' ? '7_days' : 'year_to_date', contentApprovalsFilters)}`}
            />
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
      <AccessComponent showWhenRole={['owner']}>
        <UncontrolledDropdown className="topbar__nav-dropdown">
          <DropdownToggle className="topbar__nav-dropdown-toggle">
            YouTube Comments <DownIcon />
          </DropdownToggle>
          <DropdownMenu className="topbar__nav-dropdown-menu dropdown__menu">
            <DropdownItem>
              <TopbarNavLink
                title="Comments"
                route={`/comments?page=1&range=current_month&filters.publishedAt~~from=${startDate}&filters.publishedAt~~to=${endDate}&publishedDateType=%3D&filters.sentiment=positive&filters.sentiment=negative`}
              />
            </DropdownItem>
            <DropdownItem>
              <TopbarNavLink
                title="Analysis"
                route="/youtube-comments-analysis"
              />
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </AccessComponent>
    </nav>
  );
};


TopbarNav.propTypes = {
  creatorsLink: PropTypes.string.isRequired,
  prospectsLink: PropTypes.string.isRequired,
  contentApprovalsFilters: PropTypes.objectOf(PropTypes.any).isRequired,
  priceApprovalLink: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  creatorsLink: state.creators.creatorLink,
  prospectsLink: state.creators.prospectLink,
  contentApprovalsFilters: state.contentApprovals.filters,
  priceApprovalLink: state.creators.priceApprovalLink,
});
export default connect(mapStateToProps)(TopbarNav);
